export { default as Scrollable, type ScrollableProps } from './Scrollable';
